import { Vehicle } from '../model/vehicle';
export class VehicleBuilder {
    static buildVehicle(data) {
        let vehicle = null;
        if (data) {
            vehicle = new Vehicle();
            vehicle.id = (data.id) ? data.id : (data.vehicle_id || null);
            vehicle.id_client = data.id_client || null;
            vehicle.type = data.type;
            vehicle.plate = data.plate;
            vehicle.id_gt_vehicle_information = data.id_gt_vehicle_information;
            vehicle.vehicle_information = data.vehicle_information;
            vehicle.km = (data.km) ? data.km : null;
            vehicle.km_timestamp = (data.km_timestamp) ? data.km_timestamp : null;
            vehicle.workshop_type = data.workshop_type || null;
        }
        return vehicle;
    }
    static buildVehiclePayload(vehicle) {
        return {
            vehicle_id: vehicle.id,
            type: vehicle.type,
            plate: vehicle.plate,
            umc: vehicle.umc,
            makeCode: vehicle.makeCode,
            makeDescription: vehicle.makeDescription,
            modelDescription: vehicle.modelDescription,
            propulsion_code: vehicle.propulsion_code,
            workshop_type: vehicle.workshop_type,
            km: vehicle.km,
            km_timestamp: vehicle.km_timestamp
        };
    }
}
//# sourceMappingURL=vehicle-builder.js.map